import { createStyles } from 'antd-style';

import { ThemeColors, ThemeFont, ThemeSpaces } from '../theme';

export const useNonLoggedTopBarStyles = createStyles(({ token }) => ({
  nonLoggedTopBar: {
    height: ThemeSpaces.SPACE_NORM_30,
    color: ThemeColors.COLOR_GREY3,
    fontWeight: 500,
    fontSize: ThemeFont.FONT_SIZE_SM_PLUS,
    display: 'flex',
    alignItems: 'center',

    [`@media (max-width: ${token.screenLGMax}px)`]: {
      display: 'none',
    },
  },
}));
